import React, { Component, createContext } from 'react';
import { fetchPreferences } from '../services/list_services';

export const PreferenceContext = createContext({
  preferences: {},
  fetchingPreferences: true,
  error: false,
  hasPreference: (_) => false,
});

const withPreference = (WrappedComponent) =>
  class Hoc extends Component {
    state = {
      preferences: {},
      fetchingPreferences: true,
      error: false,
    };

    componentDidMount() {
      this.fetchPreferences();
    }

    fetchPreferences = () => {
      fetchPreferences()
        .then((preferences) => {
          const parsedPreferences = preferences.reduce(
            (accumulator, currentPreference) => ({
              ...accumulator,
              [currentPreference.identifier]: currentPreference.value,
            })
          );
          this.setState({
            preferences: parsedPreferences,
            fetchingPreferences: false,
          });
        })
        .catch(() =>
          this.setState({ fetchingPreferences: false, error: true })
        );
    };

    hasPreference = (preference) => {
      const { preferences } = this.state;
      // eslint-disable-next-line no-underscore-dangle
      return preferences[preference];
    };

    render() {
      const { preferences, fetchingpreferences, error } = this.state;
      return (
        <PreferenceContext.Provider
          value={{
            error,
            fetchingpreferences,
            preferences,
            hasPreference: this.hasPreference,
          }}
        >
          <WrappedComponent
            {...this.props}
            preferences={preferences}
            hasPreference={this.hasPreference}
          />
        </PreferenceContext.Provider>
      );
    }
  };

export default withPreference;
